import styled from 'styled-components';

export const StyledContainerLocaleSelect = styled.section`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0.5rem 0;
`;

export const StyledButtonLocaleSelect = styled.button`
    display: grid;
    grid-template-columns: 20px 1fr;
    width: 100%;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    background-color: transparent;
    
    &:hover {
        background-color: transparent;

        & > img {
            transform: scale(1.2);
            transition: transform 0.3s;
        }
    }
`;

export const StyledSelectedLocale = styled.section`
    display: grid;
    grid-template-columns: 20px 1fr;
    width: 100%;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;

    & > span {
        font-family: 'Elza', sans-serif;
        font-size: 12px;
        font-weight: 400;
        line-height: 14.52px;
        text-align: center;
    }
`;

export const StyledBadgeLocale = styled.img`
    width: 20px;
    height: auto;
`;

export const StyledTextMenu = styled.span`
    color: ${({ theme }) => theme.colors.text.primary};
    font-weight: 500;
    font-size: 0.9rem;
`;
